<template>
  <span class="pr-2">
    <ArrowRightIcon :class="{rotate180: rotateArrow, rotate0: !rotateArrow}"/>
  </span>
</template>

<script setup lang="ts">
import ArrowRightIcon from "@/components/Icons/components/ArrowRightIcon.vue";
import {defineProps} from 'vue'

defineProps(
    {
      rotateArrow: Boolean,
    }
)
</script>

<style scoped>
.rotate0 {
  transition: transform 0.3s ease-in-out;
  transform: rotate(0deg);
}

.rotate180 {
  transition: transform 0.3s ease-in-out;
  transform: rotate(180deg);
}
</style>